import { List, useRecordContext } from "react-admin";
import { DrivingSchool } from "../../providers/drivingSchoolsProvider";
import { LoadingIndicator } from "../../misc/LoadingIndicator";
import { PageTitle } from "../../misc/PageTitle";
import { Button, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router";
import { Row } from "../../misc/Row";
import { EmptyState } from "../../misc/EmptyState";
import { ResponsiveListSurface } from "../../misc/ResponsiveListSurface";
import { CourseTemplatesDataGrid } from "./CourseTemplatesDataGrid";

export function DrivingSchoolCourseTemplates() {
  const drivingSchool = useRecordContext<DrivingSchool>();
  const navigate = useNavigate();

  if (!drivingSchool) {
    return (
      <>
        <PageTitle>Kursvorlagen</PageTitle>
        <LoadingIndicator />
      </>
    );
  }

  const empty = <EmptyState />;

  return (
    <div style={{ position: "relative" }} data-testid="DrivingSchoolCourseTemplatesList">
      <Row
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: "30px", minHeight: "32px", columnGap: 2, flexWrap: { xs: "wrap", sm: "nowrap" }, rowGap: 1 }}
      >
        <PageTitle documentTitle="Kursvorlagen">
          <h2 style={{ margin: 0, lineHeight: 0.83 }}>Kursvorlagen</h2>
        </PageTitle>
        <IconButton
          aria-label="Kursvorlage hinzufügen"
          color="primary"
          onClick={() => navigate("/courseTemplates/create")}
          size="small"
          sx={{ display: { xs: "inline-flex", sm: "none" } }}
        >
          <AddIcon />
        </IconButton>
        <Button
          variant="outlined"
          startIcon={<AddIcon />}
          onClick={() => navigate("/courseTemplates/create")}
          size="small"
          sx={{ display: { xs: "none", sm: "inline-flex" } }}
        >
          Hinzufügen
        </Button>
      </Row>
      <ResponsiveListSurface variant="compactStandalone">
        <List
          resource="courseTemplates"
          title=" "
          actions={false}
          filter={{ drivingSchoolId: drivingSchool.id }}
          sort={{ field: "name", order: "ASC" }}
          exporter={false}
          hasCreate={false}
          empty={empty}
        >
          <CourseTemplatesDataGrid empty={empty} />
        </List>
      </ResponsiveListSurface>
    </div>
  );
}
